import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useClient } from "context/admin/client";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import FormikPhoneInput from "components/formik/FormikPhoneInput";

import contactDataSchema from "libs/validations/contactDataSchema";

const ContactDataModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { data, updateData } = useClient();

  const onSubmit = async (values, setSubmitting) => {
    try {
      await updateData(values);
      onClose();
    } catch (err) {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{
        contact_data: {
          first_name: data?.contact_data?.first_name,
          last_name: data?.contact_data?.last_name,
          email: data?.contact_data?.email,
          phone: {
            code: data?.contact_data?.phone?.code,
            number: data?.contact_data?.phone?.number,
          },
        },
      }}
      enableReinitialize
      validationSchema={contactDataSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <ModalNew
            title={t("Change contact data")}
            variant="wide"
            loading={isSubmitting}
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={submitForm}
          >
            <Form autoComplete="off">
            <div className="form form--columns">
              <div className="form__column">
                <FormikInput
                  name="contact_data.first_name"
                  label={t("Name")}
                  disabled={isSubmitting}
                  required
                  placeholder="John"
                />
              </div>
              <div className="form__column">
                <FormikInput
                  name="contact_data.last_name"
                  label={t("Surname")}
                  disabled={isSubmitting}
                  placeholder="Doe"
                  required
                />
              </div>
              <div className="form__column">
                <FormikInput
                  name="contact_data.email"
                  label={t("Email")}
                  placeholder="j.doe@domain.com"
                  disabled={isSubmitting}
                  required
                />
              </div>
              <div className="form__column">
                <FormikPhoneInput
                  label={t("Phone")}
                  name="contact_data.phone"
                  placeholder="123 456 789"
                  disabled={isSubmitting}
                />
              </div>
            </div>
            </Form>
          </ModalNew>
      )}
    </Formik>
  );
};

export default ContactDataModal;
